import type { ClientLogEntry } from '~/interfaces/ClientLogEntry'

// Shaped like `${component}.${operation}` so mealz-api's event pattern accepts it.
export const createClientLogDroppedEntry = (dropped: number): ClientLogEntry => ({
  event: 'ClientLogs.dropped',
  level: 'warn',
  message: 'Client log entries dropped',
  context: { dropped }
})
